import React from 'react';
import Box from '@mui/material/Box';

/**
 * Eine Themen-Fläche („Sektion = Fläche", Konzept v2.4):
 * weißes Papier auf dem getönten Seitengrund — „carved": 12px-Radius,
 * Haarlinien-Rand plus hauchzarter Schatten (Design 3.0).
 * Inhalte darin bleiben rahmenlos (Ruhe-Prinzip: eine Box-Ebene).
 */
const SectionCard = ({ children, sx = {} }) => (
  <Box sx={{
    bgcolor: 'background.paper',
    border: 1, borderColor: 'divider', borderRadius: '12px',
    boxShadow: '0 1px 2px rgba(20,24,31,.05), 0 1px 1px rgba(20,24,31,.03)',
    p: 2.5, minWidth: 0, overflowWrap: 'anywhere',
    ...sx,
  }}>
    {children}
  </Box>
);

export default SectionCard;
